import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Indicates how various individuals contribute to the success of particular outcomes.',
    name: 'Outcome Assignees',
    partialId: PartialId.Standard.create('outcome_assignees'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
